export type MaybeDate = Date | string | number | null | undefined;

const isDateObject = (value: MaybeDate): value is Date =>
  value instanceof Date || Object.prototype.toString.call(value) === '[object Date]';

export const DATE_INVALID = new Date(NaN);

export function getAsDate(date: MaybeDate): Date;
export function getAsDate(date: MaybeDate, fallback: Date): Date;
export function getAsDate(date: MaybeDate, fallback: null): Date | null;
export function getAsDate(date: MaybeDate, fallback: Date | null = DATE_INVALID): Date | null {
  if (date == null || date === '') return fallback;
  return isDateObject(date) ? date : new Date(date);
}
